import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/RO';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/RO';
import { cardImage } from '../card-image/RO';
import { cardInsurance } from '../card-insurance/RO';
import { limitsChange } from '../card-limits-change/RO';
import { cardLimitsFocusPage } from '../card-limits-focus-page/RO';
import { limits } from '../card-limits/combined-limits/RO';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/RO';
import { permanentLimits } from '../card-limits/permanent-limits/RO';
import { temporaryLimits } from '../card-limits/temporary-limits/RO';
import { cardLockAndReplace } from '../card-lock-and-replace/RO';
import { cardLock } from '../card-lock/RO';
import { prepaidCardInfo } from '../card-prepaid-info/RO';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/RO';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/RO';
import { cardCancellation } from '../card-services/card-cancellation/RO';
import { cardDelivery } from '../card-services/card-delivery/RO';
import { changeCardDesign } from '../card-services/card-design-change/RO';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/RO';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/RO';
import { cardMigrationExternal } from '../card-services/card-migration-external/RO';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/RO';
import { cardReissue } from '../card-services/card-reissue/RO';
import { orderReplacementCard } from '../card-services/card-replacement/RO';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/RO';
import { changeCardDelivery } from '../card-services/delivery-management-v2/RO';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/RO';
import { changePinDelivery } from '../card-services/pin-delivery-change/RO';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/RO';
import { pinDelivery } from '../card-services/pin-delivery/RO';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/RO';
import { reprintPin } from '../card-services/reprint-pin/RO';
import { cardTracking } from '../card-tracking/RO';
import { cardUnlock } from '../card-unlock/RO';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/RO';
import { cardLimitInfo } from '../cards-bank/card-limit-info/RO';
import { cardReplacement } from '../cards-bank/card-replacement/RO';
import { geoControl } from '../cards-bank/geo-control/RO';
import { linkedAccounts } from '../cards-bank/linked-accounts/RO';
import { microCardActivation } from '../cards-bank/micro-card-activation/RO';
import { microSticker } from '../cards-bank/micro-sticker/RO';
import { cardServices } from '../cards-credit/additional-services/RO';
import { cardFees } from '../cards-credit/card-fees/RO';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/RO';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/RO';
import { creditCardMeter } from '../cards-credit/card-meter/RO';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/RO';
import { creditCardPayUp } from '../cards-credit/pay-up/RO';
import { autoRepayment } from '../cards-credit/repayment/RO';
import { creditCardStatements } from '../cards-credit/statements/RO';
import { contactlessPayments } from '../contactless-payments/RO';
import { expirationTime } from '../expiration-time/RO';
import { installmentsActivation } from '../installments-activation/RO';
import { installments } from '../installments/RO';
import { temporaryDeactivation } from '../temporary-deactivation/RO';
import { topUp } from '../top-up/RO';
import { upcomingInstallments } from '../upcoming-installments/RO';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
